import script from "./TechStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechStack.vue?vue&type=script&setup=true&lang=ts"

import "./TechStack.vue?vue&type=style&index=0&id=5dee4b94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dee4b94"]])

export default __exports__